import { useEffect, useState } from "react"

import type { RoomSocketStatus } from "../lib/ws-client"

export function ConnectionOverlay({ status, isOnline = true }: { status: RoomSocketStatus; isOnline?: boolean }) {
  const signal = status === "authed" && !isOnline ? "offline" : status
  const [delayedSignal, setDelayedSignal] = useState<string | null>(null)

  useEffect(() => {
    if ((status === "authed" && isOnline) || status === "idle" || status === "expired") {
      return
    }

    const timer = window.setTimeout(() => setDelayedSignal(signal), 1000)
    return () => window.clearTimeout(timer)
  }, [isOnline, signal, status])

  // "expired" is a terminal state and is rendered as a full-screen TerminalScreen
  // elsewhere; the overlay banner is reserved for recoverable connection states.
  if (
    (status === "authed" && isOnline) ||
    status === "idle" ||
    status === "expired" ||
    delayedSignal !== signal
  ) {
    return null
  }

  return (
    <div
      role="status"
      className="fixed inset-x-3 top-3 z-50 border-2 border-primary bg-card px-4 py-3 text-center font-mono text-xs uppercase tracking-[0.25em] text-foreground"
      style={{ boxShadow: "var(--shadow-brutal)" }}
    >
      <span className="text-primary">●</span> Signal lost · reconnecting
    </div>
  )
}
